import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"700\",\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/AppLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/src/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskModeProvider"] */ "/workspace/src/contexts/KioskModeContext.tsx");
